export const brandBgDataUrl = {
  type: "string",
  minLength: 1,
  maxLength: 2_048
};
